export default __webpack_public_path__ + "static/media/reports.c1db84fd.svg";